









































import Vue, { PropType } from 'vue'
import { faCompass } from '@fortawesome/free-solid-svg-icons'
import { invalidBodyError } from '~/services/errors'
import CAutocompleteInput from '~/components/shared/configurable/form/autocomplete/CAutocompleteInput.vue'
import { Suggestion } from '~/components/shared/configurable/form/autocomplete/Suggestion'
import { Geolocation } from '~/models/common/types'
import { Size } from '~/models/shared/types'
import GoogleMapsService from '~/services/GoogleMapsService'

export default Vue.extend({
  components: { CAutocompleteInput },
  props: {
    name: { type: String, required: false, default: '' },
    classes: { type: String, default: '' },
    value: { type: Object, default: null },
    placeholder: { type: String, default: '' },
    valueField: { type: String, default: null },
    geolocationFinderLabel: { type: String, default: null },
    inputId: {
      type: String,
      default: ''
    },
    inputSize: {
      type: String as PropType<Size>,
      default: Size.SMALL
    },
    inputClass: {
      type: String,
      default: ''
    },
    state: {
      type: Boolean,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    selectFirstOnClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      icons: {
        faCompass
      },
      postcodes: [],
      suggestions: [],
      geolocationLoading: false
    }
  },
  computed: {
    postcode() {
      return this.value && this.value.name
    }
  },
  methods: {
    async findFromGeolocation() {
      if (this.disabled) {
        return
      }
      this.geolocationLoading = true

      try {
        const googleMapsService = this.$dep(GoogleMapsService)
        const geolocation: Geolocation = await googleMapsService.getCurrentGpsGeolocation()
        const r = await this.$axios.get('/api/postcodes/closest/', {
          params: {
            lat: geolocation.lat,
            lon: geolocation.lon
          }
        })

        this.$emit('input', {
          name: r.data.data.postcode.name,
          country_code: r.data.data.postcode.country_code
        })
      } catch (error) {
        this.$logger.captureError(error)
      } finally {
        this.geolocationLoading = false
      }
    },
    /**
     * @param {string} input
     */
    async handleInputChange(input) {
      this.postcodes = await this.getPostcodes(input)
      this.suggestions = this.postcodes.map(this.getSuggestionFromPostcode)
      this.$emit('text-input', input)
    },
    /**
     * @param {string} input
     */
    handleInputSubmit(input) {
      this.$emit('input', { name: input, country_code: null })
    },
    handleSuggestionClear() {
      this.postcodes = []
      this.suggestions = []
    },
    /**
     * @param {string} id
     */
    handleSuggestionSelect(id) {
      const postcode = this.postcodes.find(postcode => postcode.name === id)
      if (!postcode) {
        return
      }

      this.$emit('input', postcode)
      this.$emit('change', postcode)
      this.postcodes = []
      this.suggestions = []
    },
    getSuggestionFromPostcode(postcode): Suggestion {
      return {
        id: postcode.name,
        displayText: postcode.name,
        displaySubtext: postcode.subtext
      }
    },
    /**
     * Gets postcodes from server.
     * @param {string} query
     * @returns {Promise<Object[]>}
     */
    async getPostcodes(query) {
      let response
      try {
        response = await this.$axios.get('/api/postcodes/search/', {
          params: { q: query }
        })
      } catch (error) {
        this.$logger.captureError(error)
        // TODO: Present error in ui
        return []
      }

      if (
        !response.data ||
        !response.data.data ||
        !response.data.data.postcodes
      ) {
        this.$logger.captureError(invalidBodyError(response.data))
        // TODO: Present error in ui
        return []
      }

      return response.data.data.postcodes
    }
  }
})
